import moment from 'moment'
import { read, utils } from 'xlsx'

import { Datepicker, FilePicker, Modal } from '@/shared'
import { type IServicePrice, type IPriceDto } from '@App/types/adminsTypes'
import { EToastings } from '@App/types/common'
import { onToasting } from '@App/utils'

import { Dates } from './Dates/Dates'
import style from './UpdatePriceModal.module.scss'
import { useFields } from './useFields'

interface IProps {
    show: boolean
    isFetching: boolean
    activateDates: string[] | null
    onClose: () => void
    onUploadFileCallback: (dto: IPriceDto) => void
    onGetPriceDataByDate: (date: string) => void
}

export const UpdatePriceModal = (props: IProps) => {
    const { show, isFetching, onClose, onUploadFileCallback, activateDates, onGetPriceDataByDate } = props

    const { date, onChangeDate } = useFields()

    const allowedFormats = ['xlsx']

    const onParseFile = (data: string[][]) => {
        const result: IServicePrice[] = []
        for (let i = 0; i <= data.length - 1; i++) {
            const row = data[i]
            if (i > 0) {
                if (row[0] && row[1] && row[2] && row[3]) {
                    result.push({ code: `${row[0]}`, name: `${row[1]}`, quantity: `${row[2]}`, price: `${row[3]}` })
                } else if (!row[0] && row[1] && !row[2] && !row[3]) {
                    continue
                } else {
                    onToasting({
                        type: EToastings.ERROR,
                        message: `Ошибка в ${i + 1} строке`
                    })
                    // break
                    return []
                }
            }
        }
        return result
    }

    const filesDataCallback = (file: File) => {
        const fileNameContent = file.name.split('.')
        const currentExtention = file.name.split('.')[fileNameContent.length - 1]
        if (allowedFormats.includes(currentExtention)) {
            const fileReadr = new FileReader()
            fileReadr.onload = function (e: any) {
                const data = e.target.result
                const readed = read(data, { type: 'binary' })
                const wsname = readed.SheetNames[0]
                const ws = readed.Sheets[wsname]
                const parsed = utils.sheet_to_json(ws, { header: 1 })
                const result = {
                    date: moment(date.value).format('YYYY-MM-DD'),
                    services: onParseFile(parsed as string[][])
                }

                result.services.length > 0 && onUploadFileCallback(result)
            }
            fileReadr.readAsBinaryString(file)
        } else {
            onToasting({
                type: EToastings.ERROR,
                message: `Допускаются файлы с расширением ${allowedFormats.join(' ')}`
            })
        }
    }

    return (
        <Modal show={show} onClose={onClose}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Обновить прайс</span>
                </div>
                <div className={style.description}>
                    <p>Для обновления прайса услуг необходимо указать дату активации.</p>
                </div>
                {activateDates && activateDates.length > 0 && (
                    <Dates isFetching={isFetching} dates={activateDates} onGetPriceDataByDate={onGetPriceDataByDate} />
                )}
                {activateDates && activateDates.length < 1 && (
                    <div className={style.emptyDates}>
                        <span>Даты активации отсутствуют</span>
                    </div>
                )}
                <div className={style.date}>
                    <Datepicker value={date.value} onChange={onChangeDate} />
                </div>
                <div className={style.filePicker}>
                    <FilePicker title='Загрузить' className={style.fileLoader} onHandleFile={filesDataCallback} />
                </div>
            </div>
        </Modal>
    )
}
